/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "#/lib/social-signal-api-client.ts"
import type {
  RequestConfig,
  ResponseErrorConfig,
} from "#/lib/social-signal-api-client.ts"
import type {
  SignupMutationRequest,
  SignupMutationResponse,
  Signup400,
} from "../types/Signup.ts"
import {
  signupMutationResponseSchema,
  signupMutationRequestSchema,
} from "../zod/signupSchema.ts"

function getSignupUrl() {
  const res = { method: "POST", url: `/signup` as const }
  return res
}

/**
 * @summary Signup for an account
 * {@link /signup}
 */
export async function signup(
  data: SignupMutationRequest,
  config: Partial<RequestConfig<SignupMutationRequest>> & {
    client?: typeof fetch
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = signupMutationRequestSchema.parse(data)

  const res = await request<
    SignupMutationResponse,
    ResponseErrorConfig<Signup400>,
    SignupMutationRequest
  >({
    method: "POST",
    url: getSignupUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return signupMutationResponseSchema.parse(res.data)
}
